const SUPPLIER_CODE = 'DSHE';

// * Store base URL is environment-specific and injected at build time
//   (see .env / vite.config.ts). Driving it from env avoids brittle
//   hostname sniffing, which breaks for hosts like
//   `maxwellthomas.directsupply.com`. Falls back to qastore for local dev.
const STORE_BASE_URL =
	process.env.DSN_STORE_BASE_URL ?? 'https://qastore.directsupply.com';

export function getStoreProductUrl(productId: string | undefined): string {
	if (!productId) return '';
	return `${STORE_BASE_URL}/Scaffolding/Product/SupplierProductDetail?supplierProductNumber=${encodeURIComponent(productId)}&supplierCode=${SUPPLIER_CODE}`;
}
